import React from 'react'

import { QueryClientProvider } from '@tanstack/react-query'

import queryClient from 'Utils/queryClient'

import SearchContent from './SearchContent'

// SearchContent is wrapped in a QueryClientProvider because the AI-mode dropdown fetches its
// grouped suggestions via react-query (useGroupedLiveSearch).
function Search(props) {
  return (
    <QueryClientProvider client={queryClient}>
      <SearchContent {...props} />
    </QueryClientProvider>
  )
}

export default Search
